import MiniHeroSection from '../components/MiniHeroSection';
import ContentBelowHeroBanner from '../components/ContentBelowHeroBanner';
import ServicesPagePostSection from '../components/ServicesPagePostSection';
import PopupSection from '../components/PopupSection';
import { Helmet } from 'react-helmet-async';
import useSWR from 'swr';
import { useState } from 'react';
import { secureFetcher, SECURITY_CONFIG } from '../config/security';

function Services() {
    const [popup, setPopup] = useState(false);

    const OpenPopup = (x) => {
        setPopup(x);
    }

    // 1. Hooks (useSWR) hamesha top par rahenge
    const { 
        data: ServicesData, 
        isLoading: servicesLoading 
    } = useSWR(`${SECURITY_CONFIG.API_BASE_URL}${SECURITY_CONFIG.WP_PAGES_ENDPOINT}/176`, secureFetcher);

    const { 
        data: servicessliderData, 
        isLoading: sliderLoading 
    } = useSWR(`${SECURITY_CONFIG.API_BASE_URL}${SECURITY_CONFIG.WP_SERVICES_ENDPOINT}?per_page=100&orderby=date&order=asc`, secureFetcher);

    // 2. Loader condition (Hamesha Hooks ke BAAD lagani hai)
    if (servicesLoading || sliderLoading) {
        return (
            <div className="text-center p-5 mt-5" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    className="spinner-border"
                    style={{ color: "#3db4e5", width: '3rem', height: '3rem' }}
                    role="status"
                >
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    // 3. Main content render
    return (
        <>
            {ServicesData && (
                <Helmet>
                    <title>{ServicesData.yoast_head_json?.title}</title>
                    <meta property="og:title" content={ServicesData.yoast_head_json?.og_title} />
                    <meta property="og:description" content={ServicesData.yoast_head_json?.og_description} />
                </Helmet>
            )}
            <MiniHeroSection data={ServicesData?.acf?.hero_banner} />
            <ContentBelowHeroBanner data={ServicesData?.acf?.content_below_hero_banner} />
            <ServicesPagePostSection 
                sliderData={servicessliderData} 
                popup={(x) => OpenPopup(x)} 
                data={ServicesData?.acf?.services_page_content} 
            />
            {popup && <PopupSection popup={(x) => OpenPopup(x)} />}
        </>
    );
}

export default Services;